module.exports = "/_next/static/images/StreamlineAccess@2x-77c743ca0f85c6702ccb3be57f661024.webp";